import { render } from "./SettingsPassword.vue?vue&type=template&id=35b84960"
import script from "./SettingsPassword.vue?vue&type=script&lang=js"
export * from "./SettingsPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__